@import "src/style/lib";

.story-page {
  .tags {
    text-transform: uppercase;
    > * {
      margin: 0 0.4em;
      white-space: nowrap;
    }
  }
  ul.tagline {
    display: flex;
    flex-wrap: wrap;
    column-gap: 1em;
    list-style: none;
    line-height: 1.4em;
    margin-top: 0.5em;
    margin-bottom: 0.4em;
    margin-left: 0;
    font-size: 1.25em;

    li {
      margin-bottom: 0;
    }

    li:before {
      content: "●";
      color: $bjelin_middlegrey;
      margin-right: 0.25em;
    }
  }

  .content-section {
    .content-section-container {
      max-width: 56rem;
      .cockpit-bjelin_text {
        font-family: "Libre Baskerville", Baskerville, "Times New Roman", Times,
          serif;
        font-size: 1.1rem;
        letter-spacing: -0.01em;
        line-height: 1.7;

        * {
          letter-spacing: -0.01em;
          line-height: 1.7;
        }

        h1,
        h2,
        h3 {
          font-weight: 700;
        }
      }
    }

    &.gallery-section .content-section-container,
    &.product-grid-section .content-section-container,
    &.story-grid-section .content-section-container {
      max-width: 87.5rem;
    }
  }

  .goto-story-container {
    display: none;
    @media screen and (min-aspect-ratio: 1/1.35) and (max-aspect-ratio: 2/1) {
      display: flex;
    }
    position: absolute;
    width: 100%;
    justify-content: center;
    z-index: 3;
    bottom: 1rem;
  }

  .btn-goto-story {
    display: none;
    cursor: pointer;
    position: relative;
    height: 2.5rem;
    font-size: 1.5em;
    line-height: 2.5rem;
    text-align: center;
    border-radius: 1.25rem;
    padding: 0 1.2rem;
    border: none;
    color: $bjelin-dark-grey;
    background: RGBA(255, 255, 255, 0.8);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
    @media screen and (min-aspect-ratio: 1/1.35) and (max-aspect-ratio: 2/1) {
      display: block;
    }
    transition: transform 0.25s ease-in-out;
    .icon {
      transition: transform 0.25s ease-in-out;
    }

    &:hover {
      background: RGBA(255, 255, 255, 1);
      transform: translateY(0.15rem);
      .icon {
        transform: scale(1.1) translateY(0.1rem);
      }
    }
  }

  .scroll-gallery {
    @media screen and (max-aspect-ratio: 1/1.35) {
      height: 100cqw;
      > .carousel > .carousel-container {
        height: 100cqw;
      }
    }
    @media screen and (min-aspect-ratio: 2/1) {
      height: calc(100cqh - 92px - var(--menu-height) - var(--padding-top));
      > .carousel > .carousel-container {
        height: calc(100cqh - 92px - var(--menu-height) - var(--padding-top));
      }
    }

    ol.breadcrumb {
      position: absolute;
      top: calc(var(--menu-height) + 25px);
      left: 33px;
      line-height: 2.4em;
      padding: 0 1em;
      border-radius: 1.2em;
      background: var(--bjelin-dark-glass-bg);
      text-shadow: 0 0 1px rgba(0, 0, 0, 0.7);

      a {
        color: #fff;
      }
    }
  }

  .case-details {
    position: relative;
    display: block;
    @media screen and (min-aspect-ratio: 1/1.35) {
      display: flex;
      gap: 3px;
      margin: 0 3px;
      min-height: 240px;
    }

    .case-details-col1 {
      padding: 20px 30px;
      background-color: $bjelin-smoke;
      @media screen and (max-width: 44rem) {
        font-size: 0.85em;
        padding: 10px 25px;
      }
      @media screen and (min-aspect-ratio: 1/1.35) {
        flex: 0 0 calc(60cqw - 9px);
      }

      h1 {
        font-size: 1.8em;
        line-height: 1.15;
        //font-size: max(7cqw, 25px);
        margin-top: 0.2em;
        margin-bottom: 0.4em;
      }
      ul {
        font-size: 1em;
        //font-size: max(2.5cqw, 14px);
      }
    }
    .case-details-col2 {
      padding: 20px 40px;
      background-color: $bjelin-light-grey;
      @media screen and (max-width: 44rem) {
        font-size: 0.85em;
        padding: 10px 25px;
      }
      @media screen and (min-aspect-ratio: 1/1.35) {
        flex: 0 0 40cqw;
      }

      ul {
        list-style: none;
        //font-size: max(2.5cqw, 14px);
        line-height: 1.4em;
        margin-top: 0.5em;
        margin-bottom: 0.4em;
        margin-left: 0;

        li {
          margin-bottom: 0.2rem;

          .product-links {
            &::before {
              content: " ";
            }
            .product-link:not(:nth-of-type(1)) {
              &::before {
                content: ", ";
              }
            }
          }
        }
      }
    }
  }
}
